const getCompanyInvoiceTypesDescription = (invoiceTypes) => {
  if (invoiceTypes.includes(10)) {
    if (invoiceTypes.includes(30)) {
      return "Direct & Indirect";
    } else {
      return "Direct";
    }
  } else {
    return "Indirect";
  }
};

const doesCompanyHaveBothInvoiceTypes = (companyInvoiceTypes) => {
  return companyInvoiceTypes.includes(10) && companyInvoiceTypes.includes(30);
};

export { doesCompanyHaveBothInvoiceTypes, getCompanyInvoiceTypesDescription };
